import React, { useMemo } from "react";
import { Chart } from "react-chartjs-2";
import "chart.js/auto";

const MONTH_LABELS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const MonthlyProfitsChart = ({ withdrawHistory }) => {
  const { labels, profits } = useMemo(() => {
    const buckets = {};

    (withdrawHistory || []).forEach((item) => {
      if (!item || item.status !== "done" || !item.dateTime) {
        return;
      }

      const date = new Date(String(item.dateTime).replace(" ", "T"));
      if (isNaN(date.getTime())) {
        return;
      }

      const key = `${date.getFullYear()}-${String(
        date.getMonth() + 1
      ).padStart(2, "0")}`;

      const amount = parseFloat(item.withdrawAmountInUsd) || 0;
      buckets[key] = (buckets[key] || 0) + amount;
    });

    const sortedKeys = Object.keys(buckets).sort();
    const labels = sortedKeys.map((key) => {
      const [year, month] = key.split("-");
      return `${MONTH_LABELS[Number(month) - 1]} ${year}`;
    });
    const profits = sortedKeys.map((key) =>
      Number(buckets[key].toFixed(2))
    );

    return { labels, profits };
  }, [withdrawHistory]);

  const data = {
    labels,
    datasets: [
      {
        type: "bar",
        label: "Profits Earned",
        data: profits,
        backgroundColor: "#3ad17e",
        borderColor: "#3ad17e",
        borderWidth: 1,
        borderRadius: 6,
        barThickness: 28,
        categoryPercentage: 0.6,
        barPercentage: 0.6,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#7c847e" },
      },
      y: {
        beginAtZero: true,
        grid: { display: false },
        ticks: {
          color: "#7c847e",
          callback: (value) => `$${value}`,
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: "top",
        labels: { color: "#a7b2ab" },
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (tooltipItem) =>
            `${tooltipItem.formattedValue} USD Profit`,
        },
        backgroundColor: "#151617",
        titleFont: { size: 12, weight: "bold" },
        bodyFont: { size: 12 },
        borderColor: "rgba(255,255,255,.15)",
        borderWidth: 1,
        cornerRadius: 8,
        displayColors: false,
      },
    },
  };

  return (
    <div className="w-full relative" style={{ height: "300px" }}>
      <Chart type="bar" data={data} options={options} />
    </div>
  );
};

export default MonthlyProfitsChart;
